import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, {Toaster} from 'react-hot-toast';
import Select from 'react-select';

import { DataContext } from '../../../../init/getData';


const SerialStockTransfer = (props) => {


  const { api, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;
  
  const { showModal, toggleModal, refreshTable, idRow, wareHouseId } = props;
  const {wareHouseData} = useContext(DataContext);
  const [toWareHouse, setToWareHouse] = useState({});

  const [loadingEffect, setLoadingEffect] = useState(false);


  // Handle Submit 
  const handleSubmit = async (e) => {
    setLoadingEffect(true);
    e.preventDefault();
    const form = document.getElementById("form");
      
    const formData = new FormData(form);
    const data = Object.fromEntries(formData);

    data['productId'] = idRow.id;  
    data['createdBy'] = userId;  

    data['fromWareHouse'] = wareHouseId;  
    data['toWareHouse'] = toWareHouse; 

    
    let res = await api.post(`/stock/transferSerial`, JSON.stringify(data))
    if(res.data.status){
      toast.success(res.data.message);
      toggleModal();
      form.reset();
      refreshTable();
      setToWareHouse({});
    }else{
      toast.error(res.data.message);
    }

    setLoadingEffect(true);
  }

  const closeModal = () => {
    toggleModal();
    setToWareHouse({});
  }

  // WareHouse Options
  const wareHouseOption = wareHouseData.map(item => ({
    value: item.id,
    label: item.name
  }));

  const wareHouseOptions = wareHouseOption.filter(
    item => item.value !== wareHouseId.value
  );


  return (
      <Modal show={showModal} onHide={toggleModal} >
      <Modal.Header style={{ background: "#1f2937" }}>
      <Modal.Title style={{ color: "white" }}>Transfer Serial Product</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <form onSubmit={handleSubmit} id='form'>

      <div className="modal-body">


      <div className="mb-3 row">
      <label className="col-sm-2 col-form-label">toStock</label>
      <div className="col-sm-10">
      <Select
            options={wareHouseOptions}
            isSearchable={true}
            placeholder="Select"
            value={toWareHouse}
            onChange={setToWareHouse}
            />
        </div>
      </div>


      <div className="mb-3 row">
        <label className="col-sm-2 col-form-label">Serial</label>
        <div className="col-sm-10">
          <input type="number" step="any" name="serial" id="serial" className="form-control"></input>
        </div>
      </div>


      <div className="mb-3 row">
          <label className="col-sm-2 col-form-label">Details</label>
          <div className="col-sm-10">
            <textarea type="text" step="any" name="details" id="details" className="form-control"></textarea>
          </div>
        </div>






  

</div>

      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" onClick={closeModal}>
          Close
        </button>
        <button className="btn btn-primary" onClick={handleSubmit}>Yes
        {loadingEffect && 
        <span className="spinner-border spinner-border-sm" style={{ marginLeft: '10px'}} role="status" aria-hidden="true"></span>
          }
        </button>
      </div>
      </form>
      </Modal.Body>
      </Modal>
      )
}


export default SerialStockTransfer;